export const HIGHLIGHTED_FAQ_VIEW_COUNTS_KEY = "highlightedFAQViewCounts";
export const HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY =
  "highlightedAppLocationViewCounts";
export const API_VERSION = "apiVersion";
export const QUOTE_COMPARISON_DEFAULT_CRITERIA_KEY =
  "quoteComparisonDefaultCriteria";
export const PREVIOUS_VEHICLE_SEARCH_QUERY_KEY = "previousVehicleSearchQuery";
export const AI_BUTTON_ANIMATION_COUNT_KEY = "aiButtonAnimationCount";

export const getLocalStorageItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

export const setLocalStorageItem = <T>(key: string, value: T) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const INTENDED_ROUTE_KEY = "intendedRoute";

/**
 * Store the intended route that the user was trying to access before being redirected to login
 */
export const storeIntendedRoute = (route: string): void => {
  setLocalStorageItem(INTENDED_ROUTE_KEY, route);
};

/**
 * Get the intended route that was stored before login redirect
 */
export const getIntendedRoute = (): string | null => {
  return getLocalStorageItem<string>(INTENDED_ROUTE_KEY);
};

/**
 * Clear the stored intended route (typically called after successful login)
 */
export const clearIntendedRoute = (): void => {
  localStorage.removeItem(INTENDED_ROUTE_KEY);
};
